
import React from 'react';
import TasksList from './TasksList';
import RegulatoryUpdates from './RegulatoryUpdates';

const ActivitySection: React.FC = () => {
  return (
    <div className="grid gap-6 md:grid-cols-2">
      <TasksList />
      <RegulatoryUpdates />
    </div>
  );
};

export default ActivitySection;
